import type { FeatureCollection, LineString } from 'geojson';
import polylinesToFeatureCollection from '@alltrails/maps/utils/polylinesToFeatureCollection';
import { baseApi } from '@alltrails/redux-helpers/baseApi';
import type { UserId } from '@alltrails/types/User';
import HeatmapOptionsData from '../types/HeatmapOptionsData';

export const heatmapsApi = baseApi.enhanceEndpoints({}).injectEndpoints({
  endpoints: builder => ({
    getHeatmapOptionsData: builder.query<HeatmapOptionsData, void>({
      query: () => {
        return { url: '/api/alltrails/map_overlays/heatmaps/options' };
      }
    }),
    // Personal (polyline) heatmap. Endpoint always returns the *current* user's
    // tracks regardless of any userId in the path (the controller 404s on a
    // mismatch), so userId is effectively just a cache key — pass the current
    // user's id and use `skip` from RTK Query to avoid firing while logged-out.
    //
    // Response from the server is gzipped JSON `string[]` of Google-encoded
    // polylines. The browser transparently inflates `Content-Encoding: gzip`,
    // so the body lands as the parsed array. We decode + GeoJSON-ify here so
    // RTK Query caches the renderable FeatureCollection, not the raw strings —
    // consumers can mount/unmount the layer freely without re-decoding.
    getPersonalHeatmap: builder.query<FeatureCollection<LineString>, UserId>({
      query: userId => ({ url: `/api/alltrails/users/${userId}/heatmap` }),
      transformResponse: (polylines: string[]) => polylinesToFeatureCollection(polylines)
    })
  })
});

export const { useGetHeatmapOptionsDataQuery, useGetPersonalHeatmapQuery } = heatmapsApi;
